import request from '@/utils/request';

export function getShopCashPage(query) {
  return request({
    url: '/api/system/shopCash/queryShopCashPage',
    method: 'post',
    data: query
  });
}

export function getShopCashList(query) {
  return request({
    url: '/api/system/shopCash/queryShopCashList',
    method: 'post',
    data: query
  });
}

export function updateShopCash(form) {
  return request({
    url: '/api/system/shopCash/updateShopCash',
    method: 'post',
    data: form
  });
}

export function saveShopCash(form) {
  return request({
    url: '/api/system/shopCash/saveShopCash',
    method: 'post',
    data: form
  });
}

export function saveCash(form) {
  return request({
    url: '/api/system/shopCash/saveCash',
    method: 'post',
    data: form
  });
}

export function deleteShopCash(id) {
  return request({
    url: '/api/system/shopCash/deleteShopCash',
    method: 'post',
    data: {'id': id}
  });
}

export function getShopCashById(id) {
  return request({
    url: '/api/system/shopCash/getShopCash',
    method: 'post',
    data: {'id': id}
  });
}

export function audit(form) {
  return request({
    url: '/api/system/shopCash/audit',
    method: 'post',
    data: form
  });
}

export function noAudit(form) {
  return request({
    url: '/api/system/shopCash/noAudit',
    method: 'post',
    data: form
  });
}




// WEBPACK FOOTER //
// ./src/api/mine/cash.js